import * as React from 'react'
import * as Device from '../service/device'
import * as Keys from '../service/keys'


const PLACEHOLDER = 'Type here to find a great name'


export default class Input extends React.PureComponent<{
  value: string
  onRef?: (ref: HTMLInputElement | null) => void
  onChange: (value: string) => void
}> {

  onKeyDown = (event) => {
    switch (event.which) {
      case Keys.ENTER:
      case Keys.UP:
      case Keys.DOWN:
      case Keys.SPACE:
        event.preventDefault()
    }
  }

  onChange = (event) => {
    this.props.onChange(event.target.value)
  }

  onRef = ref => {
    this.props.onRef && this.props.onRef(ref)
  }

  render() {
    const { value } = this.props

    return (
      <div className="search">
        <input
          ref={this.onRef}
          type="text"
          value={value}
          onChange={this.onChange}
          onKeyDown={this.onKeyDown}
          autoFocus={Device.IS_DESKTOP}
          placeholder={Device.IS_DESKTOP ? '' : PLACEHOLDER}
          spellCheck={false}
          autoCorrect="off"
          autoCapitalize="off"
          autoComplete="off"
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/comp/input.tsx